import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useToastStore = defineStore('toasts', () => {
  const items = ref([])
  let nextId = 1

  function push({ code, kind = 'error', retryAfterSeconds = null }) {
    const id = nextId++
    items.value.push({ id, code, kind, retryAfterSeconds })
    return id
  }

  function dismiss(id) {
    items.value = items.value.filter((item) => item.id !== id)
  }

  function pushFromError(error) {
    if (error?.status === 429) {
      return push({ code: 'too_many_attempts', retryAfterSeconds: error.retryAfterSeconds ?? null })
    }
    if (error?.isNetwork) return push({ code: 'offline' })
    if (error?.status >= 500) return push({ code: 'server_error' })
    return push({ code: error?.code ?? 'unknown' })
  }

  return { items, push, dismiss, pushFromError }
})
